import type { OpenApiSpec, EndpointSummary, HttpMethod, Schema } from './types';

const METHODS: HttpMethod[] = ['get', 'post', 'put', 'patch', 'delete'];

export function listEndpoints(spec: OpenApiSpec): EndpointSummary[] {
    const out: EndpointSummary[] = [];
    for (const [path, item] of Object.entries(spec.paths || {})) {
        for (const m of METHODS) {
            const op = item[m];
            if (!op) continue;
            const tag = op.tags?.[0] || 'Lainnya';
            const operationId = op.operationId || `${m}_${path}`;
            out.push({
                operationId,
                method: m,
                path,
                summary: op.summary || path,
                description: op.description,
                tag,
            });
        }
    }
    return out;
}

export function findEndpoint(spec: OpenApiSpec, operationId: string): {
    summary: EndpointSummary;
    op: any;
    pathItem: any;
} | null {
    for (const [path, item] of Object.entries(spec.paths || {})) {
        for (const m of METHODS) {
            const op = item[m];
            if (op && (op.operationId === operationId || `${m}_${path}` === operationId)) {
                return {
                    summary: {
                        operationId: op.operationId || `${m}_${path}`,
                        method: m,
                        path,
                        summary: op.summary || path,
                        description: op.description,
                        tag: op.tags?.[0] || 'Lainnya',
                    },
                    op,
                    pathItem: item,
                };
            }
        }
    }
    return null;
}

/** Resolve $ref pointer like `#/components/schemas/Task` */
export function resolveRef(spec: OpenApiSpec, ref: string): Schema | null {
    if (!ref.startsWith('#/')) return null;
    const parts = ref.slice(2).split('/');
    let node: any = spec;
    for (const p of parts) {
        if (!node || typeof node !== 'object') return null;
        node = node[p];
    }
    return (node as Schema) || null;
}

/** Deep-resolve schema $refs (one level — enough for our spec). */
export function resolveSchema(spec: OpenApiSpec, schema: Schema | undefined): Schema {
    if (!schema) return {};
    if (schema.$ref) {
        const resolved = resolveRef(spec, schema.$ref);
        return resolved || {};
    }
    return schema;
}
